import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Notice} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {NoticesService} from '../../../services/notices.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'choose-icon-modal',
    templateUrl: './choose-icon-modal.component.html',
    styleUrls: ['./choose-icon-modal.component.scss']
})
export class ChooseIconModalComponent implements OnInit {
    @ViewChild('form') form;
    @ViewChild('topLogoInput') topLogoInput;
    showModal = false;
    tags: Array<any> = [];
    listPrivateIcons: Array<any> = [];
    listSharedIcons: Array<any> = [];
    data: Notice = new Notice();
    disabledSubmit = false;
    search = '';
    tab = 0;
    uploaderIcon = {queue: []};
    file = {};
    itemList = [];
    selectedItems = [];
    settings = {
        singleSelection: false,
        text: 'Tags',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        badgeShowLimit: 5
    };
    smallSettings = {
        singleSelection: false,
        text: 'Tags',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        badgeShowLimit: 1,
        classes: 'icon-tag-select'
    };

    constructor(
        public api: ApiClientService,
        public noticesService: NoticesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.itemList = [
            { id: 1, itemName: 'India' },
            { id: 2, itemName: 'Singapore' },
            { id: 3, itemName: 'Australia' },
            { id: 4, itemName: 'Canada' },
            { id: 5, itemName: 'South Korea' },
            { id: 6, itemName: 'Brazil' }
        ];
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        // this.getNoticeCategories();
        if (this.noticesService.noticeInNoticeModal) {
            this.data = this.noticesService.noticeInNoticeModal;
            // this.noticeName = this.data.noticeName;
            // this.categoryId = this.data.categoryId;
        }
    }

    hideModal() {
        this.noticesService.isChooseIconModalShow = false;
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.noticeName) toastr.warning('Notice name should not be blank.');
            return;
        }

        let data: any = this.noticesService.noticeInNoticeModal;
        data.noticeName = form.value.noticeName;
        data.noticeCategory = form.value.noticeCategory;
        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainNotices', `/v1/incident_report/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Notice successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Notice failed');
                }
            );
        } else {
            this.api.post('domainNotices', '/v1/incident_report.json', data).subscribe(
                () => this.updateView('Notice successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Notice failed');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.noticesService.getData();
        this.form.reset();
        this.hideModal();
    }

    back(): void {
        this.noticesService.isNoticeInfoShow = false;
        this.noticesService.isNoticeScheduleShow = true;
        this.noticesService.step = 'schedule';
    }

    noticeCategorySelect(arr: Array<any>) {
        return arr.map(
            noticeCategory => (
                {value: noticeCategory.id, optionText: noticeCategory.name}
            )
        );
    }

    setImage(icon) {
        // document.getElementsByClassName('note-editable')[0].innerHTML = `<img src="${icon}">`;
        document.getElementsByClassName('note-editable')[0].innerHTML += '<img style="width: 500px;" src="https://www.w3schools.com/w3css/img_fjords.jpg">';
        this.hideModal();
    }

    editTags(item, tag) {

    }

    uploadIcon(file) {

    }

    changed(data) {

    }

    launchFilePicker(): void {
        this.topLogoInput.nativeElement.click();
    }

    onItemSelect(item: any) {
        console.log(item);
    }
    OnItemDeSelect(item: any) {
        console.log(item);
    }
    onSelectAll(items: any) {
        console.log(items);
    }
    onDeSelectAll(items: any) {
        console.log(items);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/notices/choose-icon-modal/choose-icon-modal.component.ts